module.exports = {"URL":"https://village2.extensionsoft.biz/api/"}


//////////////////
// WEBPACK FOOTER
// ./static/config.json
// module id = 144
// module chunks = 34